import PasswordValidation from "./PasswordValidation";

export default PasswordValidation;